export default __webpack_public_path__ + "static/media/Mysore_Chamudeswari temple_2.2bb506ac.jpg";